export default defineNuxtRouteMiddleware((to, from) => {
    const event = useRequestEvent()
    
    if (to.path.startsWith('/_nuxt/')) {
      event.node.res.setHeader('Cache-Control', 'no-cache, no-store, must-revalidate')
    }
}) 
